import bug from "../images/types/bug.png";
import dark from "../images/types/dark.png";
import dragon from "../images/types/dragon.png";
import electric from "../images/types/electric.png";
import fairy from "../images/types/fairy.png";
import fighting from "../images/types/fighting.png";
import fire from "../images/types/fire.png";
import flying from "../images/types/flying.png";
import ghost from "../images/types/ghost.png";
import grass from "../images/types/grass.png";
import ground from "../images/types/ground.png";
import ice from "../images/types/ice.png";
import normal from "../images/types/normal.png";
import poison from "../images/types/poison.png";
import psychic from "../images/types/psychic.png";
import rock from "../images/types/rock.png";
import steel from "../images/types/steel.png";
import water from "../images/types/water.png";

const TypeImageMap = {
    "bug": bug,
    "dark": dark,
    "dragon": dragon,
    "electric": electric,
    "fairy": fairy,
    "fighting": fighting,
    "flying": flying,
    "fire": fire,
    "ghost": ghost,
    "grass": grass,
    "ground": ground,
    "ice": ice,
    "normal": normal,
    "poison": poison,
    "psychic": psychic,
    "rock": rock,
    "steel": steel,
    "water": water
}

export default TypeImageMap;
